"use client"

import { useEffect, useState } from "react"

import { getLastCheckoutProduct, useLastCheckoutProduct } from "@lib/util/checkout-cookie"

const CartNotificationIndicator = () => {
  const lastProduct = useLastCheckoutProduct()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const product = getLastCheckoutProduct()

    if (product) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }, [lastProduct])

  return <div className={`absolute -right-1 -top-1 h-3 w-3 rounded-full border border-white bg-red-500 ${!isVisible ? "hidden" : ""}`} />
}

export default CartNotificationIndicator
